import React from 'react';

import Typography from '@johnlewispartnership/wtr-ingredients/dist/foundations/typography';
import { SitewideInPage } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Sitewide/InPage';

export const UnsupportedBrowserBanner = () => (
  <SitewideInPage variant="offer" data-testid="unsupportedBrowserBanner">
    <Typography noMargins element="p">
      This site will not work correctly unless you use a modern browser. Try downloading one of the
      following:
    </Typography>
    <Typography noMargins element="p">
      <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a> |{' '}
      <a href="https://www.google.co.uk/chrome/">Google Chrome</a> |{' '}
      <a href="https://www.mozilla.org/en-GB/firefox/">Mozilla Firefox</a>
    </Typography>
  </SitewideInPage>
);
